import { informationStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import { css } from "styled-components";

informationStyles.headingAndTextStyles = {
    ...informationStyles.headingAndTextStyles,
    heading: {
        ...informationStyles.headingAndTextStyles?.heading,
        variant: "h4",
        css: css`
            ${informationStyles.headingAndTextStyles?.heading?.css}
            margin-bottom: 8px;
        `,
    },
};

informationStyles.informationGridItem = {
    ...informationStyles.informationGridItem,
    css: css`
        ${informationStyles.informationGridItem?.css}
        margin-bottom: 10px;
    `,
};

informationStyles.billingAddressStyle = {
    ...informationStyles.billingAddressStyle,
    headerText: {
        ...informationStyles.billingAddressStyle?.headerText,
        variant: "h4",
        css: css`
            ${informationStyles.billingAddressStyle?.headerText?.css}
            margin-bottom: 24px;
        `,
    },

    titleText: {
        ...informationStyles.billingAddressStyle?.titleText,
        variant: "h5",
        css: css`
            ${informationStyles.billingAddressStyle?.titleText?.css}
            margin-bottom: 24px;
        `,
    },

    addressDisplay: {
        ...informationStyles.billingAddressStyle?.addressDisplay,
        wrapper: {
            ...informationStyles.billingAddressStyle?.addressDisplay?.wrapper,
            css: css`
                p {
                    line-height: 180%;
                }
            `,
        },
    },
};

informationStyles.shippingAddressStyle = {
    ...informationStyles.shippingAddressStyle,
    headerText: {
        ...informationStyles.shippingAddressStyle?.headerText,
        variant: "h4",
        css: css`
            ${informationStyles.shippingAddressStyle?.headerText?.css}
            margin-bottom: 24px;
        `,
    },

    titleText: {
        ...informationStyles.shippingAddressStyle?.titleText,
        variant: "h5",
        css: css`
            ${informationStyles.shippingAddressStyle?.titleText?.css}
            margin-bottom: 24px;
        `,
    },

    addressDisplay: {
        ...informationStyles.shippingAddressStyle?.addressDisplay,
        wrapper: {
            ...informationStyles.shippingAddressStyle?.addressDisplay?.wrapper,
            css: css`
                p {
                    line-height: 180%;
                }
            `,
        },
    },
};
